// ExportCVSiteDialog.tsx — Export the current project's site layout as a .cvsite file

import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import { exportSiteCVSite } from '../utils/cvpFormat';

export default function ExportCVSiteDialog() {
  const project = useShallowStore(s => s.project);
  const hasSite = !!project?.site;

  return (
    <DialogBase
      title="Export Site (.cvsite)"
      okLabel="Export"
      onOk={() => project && exportSiteCVSite(project)}
    >
      {!project ? (
        <p className="dialog-warning">No project open. Please open or create a project first.</p>
      ) : !hasSite ? (
        <p className="dialog-warning">
          No site plan exists for this project. Use Site → Site Setup to create one first.
        </p>
      ) : (
        <>
          <p className="dialog-info">
            Exporting site layout for <strong>{project.name}</strong> as a native CV site file.
          </p>
          <p className="dialog-info">
            {project.site!.panels.length} panel placement(s) · scale {project.site!.scale}
          </p>
          <p className="dialog-info">
            Import into any project with File → Import CV File to replace that project's site layout.
          </p>
        </>
      )}
    </DialogBase>
  );
}
